module.exports = __webpack_public_path__ + "static/img/index-icon-3.4d77545f.png";